export default function Maintenance() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="text-center p-6 bg-white rounded shadow-md">
                <h1 className="text-4xl font-bold mb-4">
                    We will be back soon
                </h1>
                <p className="text-lg">
                    Sorry for the inconvenience—our site is under maintenance.
                </p>
            </div>
        </div>
    )
}
